'use client';

import React from 'react';

interface CountdownRingProps {
  secondsRemaining: number;
  ttlSeconds: number;
}

export default function CountdownRing({ secondsRemaining, ttlSeconds }: CountdownRingProps) {
  const radius = 28;
  const circumference = 2 * Math.PI * radius;
  const progress = secondsRemaining / ttlSeconds;
  const dashOffset = circumference * (1 - progress);
  const isUrgent = secondsRemaining <= 8;

  return (
    <div className="relative flex items-center justify-center w-20 h-20">
      <svg width="80" height="80" viewBox="0 0 80 80" style={{ transform: 'rotate(-90deg)' }}>
        {/* Track */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.08)"
          strokeWidth="5"
        />
        {/* Progress */}
        <circle
          cx="40"
          cy="40"
          r={radius}
          fill="none"
          stroke={isUrgent ? 'var(--kiosk-amber)' : 'var(--kiosk-blue-bright)'}
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          style={{ transition: 'stroke-dashoffset 1s linear, stroke 0.5s ease' }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <span
          className={`tabular-nums text-xl font-bold ${isUrgent ? 'text-kiosk-amber' : 'text-kiosk-blue'}`}
        >
          {secondsRemaining}
        </span>
      </div>
    </div>
  );
}